//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "complaintComment",
    data() {
        return {
            radio: '0',
            degree: 0,
            value: '',
            saving: false,
            complaintRecordId: 0
        }
    },
    methods: {
        onSave() {
            if (this.complaintRecordId == 0) {
                return;
            }
            var page = {
                id: 0,
                complaintRecordId: this.complaintRecordId,
                operatorType: 5,
                visitResult: parseInt(this.radio),
                dealWithRemark: this.value,
                file: {associateType: 'ComplaintInfoFile'},
                degree: this.degree
            }
            if (page.operatorType == 5) {
                if (page.visitResult == 1) {
                    page.operatorType = 4;
                } else {
                    page.operatorType = 5;
                }
            }
            console.log(page);
            // return;
            this.saving = true;
            abp.ajax.post('/api/services/app/ComplaintRecord/SaveComplaintChuLi', page).then(() => {
                this.$router.back();
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    created() {
        this.complaintRecordId = parseInt(this.$route.params.id) || 0;
    }
}
